export default __webpack_public_path__ + "static/media/1903.511a921d.png";